<template>
  <b-row style="margin-top: 2em">
    <b-col>
      <b-card bg-variant="light">
        <b-row>
          <b-col>
            <h5 class="text-info m-1">{{ $t("globals.invoices") }}:</h5>
          </b-col>
          <b-col>
            <b-btn
              v-if="invoicesAny"
              size="sm"
              class="float-right m-1"
              @click="downloadInvoicesCsv"
              :title=" $t('globals.download_csv')"
            >
              <v-icon name="file-download"></v-icon>
            </b-btn>
            <b-btn
              v-if="getUserBrandPermissions.super_admin"
              size="sm"
              variant="info"
              class="float-right m-1"
              :disabled="!selectedItemsAny"
              @click="updateInvoices"
            >
              {{ $t("globals.update_selected") }}
            </b-btn>
          </b-col>
        </b-row>
        <!-- Search row -->
        <b-row class="my-2">
          <b-col>
            <b-input-group class="m-1">
              <b-form-input
                v-model="filter"
                :placeholder="$t('globals.type_to_search')"
              />
              <b-input-group-append>
                <b-btn
                  size="sm"
                  variant="warning"
                  :disabled="!filter"
                  @click="filter = ''"
                >
                  {{ $t("globals.clear") }}
                </b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col cols="2" class="m-1">
            <b-form-select v-model="perPage" :options="perPageOptions" />
          </b-col>
        </b-row>
        <!-- Table -->
        
        <b-row>
          <b-col>
            <b-table
              class="m-1"
              :items="invoices"
              :fields="fields"
              :filter="filter"
              :current-page="currentPage"
              @filtered="currentPage = 1"
              :sortable = false
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              small hover
              
              
              @row-clicked='rowClicked'
              caption-top
              sort-icon-left
            >
              <template v-slot:table-caption>
                {{ $t("globals.selected") + ": " + invoices.filter(e => e.selected).length }}
              </template>
              <template v-slot:cell(id)="item">
                <b-form-checkbox
                  v-model="item.item.selected"
                  :value="true"
                  :unchecked-value="false"
                >
                  {{ item.item.id }}
                </b-form-checkbox>
              </template>
              <template v-slot:cell(is_paid)="item">
                  <v-icon v-if="item.item.is_paid" name="regular/check-square" ></v-icon>
                  <v-icon v-else name="regular/square" ></v-icon>
                </template>
              <template v-slot:head(id)>
                <b-form-checkbox
                  @change="toggleAll"
                  :disabled="!invoicesAny"
                >
                  {{ "ID" }}
                </b-form-checkbox>
              </template>
              <template v-slot:cell(total_price)="item">
                {{ currencyFormat(item.item.total_price, currency) }}
              </template>
              <template v-slot:cell(created_at)="item">
                <div v-b-tooltip.hover :title="item.item.created_at">
                  {{ item.item.created_at.substring(0, 10) }}
                </div>
              </template>
              <template v-slot:cell(invoice_no)="item">
                <a :href="`${getBackendUrl}/pdf_invoices/${item.item.id}.pdf?tmpl=0&locale=${getLocale}`" target="_blank">
                  {{ item.item.invoice_no }}
                </a>
              </template>
              <template v-slot:cell(sent_at)="item">
                <div
                  v-b-tooltip.hover
                  :title="item.item.sent_at ? item.item.sent_at : ''"
                >
                  {{
                    item.item.sent_at ? item.item.sent_at.substring(0, 10) : ""
                  }}
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <!-- Pagination -->
        <b-row>
          <b-col md="6" class="my-1">
            <b-pagination
              :total-rows="total"
              :per-page="perPage"
              v-model="currentPage"
              class="my-0"
            />
          </b-col>
        </b-row>
        <!-- Hidded download eleent -->
        <a
          href=""
          id="csvdownloadlink"
          ref="csvfiledownload"
          hidden="true"
          download=""
        ></a>
      </b-card>
    </b-col>
   
  </b-row>
</template>

<script>
import { currencyFormat } from "@/helpers/price";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  props: {
    customer:{
      type: Number,
      require: true
    },
    company_name: String,
    currency: String,
    

  },
  data() {
    return {
      total:0,
      invoices:[],
      filter: null,
      currentPage: 1,
      sortBy: "sent_at",
      sortDesc: true,
      perPage: 10,
      perPageOptions: [
        { text: "10 " + this.$t("globals.per_page"), value: 10 },
        { text: "20 " + this.$t("globals.per_page"), value: 20 },
        { text: "30 " + this.$t("globals.per_page"), value: 30 }
      ],
      fields: [
        "id",
        {
          key: "invoice_no",
          label: this.$t("globals.invoice_no"),
          sortable: true
        },
        {
          key: "is_paid",
          label: this.$t("globals.paid"),
          sortable: true
        },
        {
          key: "created_at",
          label: this.$t("globals.created_at"),
          sortable: true
        },
        {
          key: "sent_at",
          label: this.$t("globals.sent_at"),
          sortable: true
        },
        {
          key: "sent_to",
          label: this.$t("globals.sent_to"),
          sortable: true
        },
        {
          key: "total_price",
          label: this.$t("globals.total_price"),
          sortable: true
        }
      ],
      items: []
    };
  },
  computed: {
    ...mapGetters(["getLocale", "getBackendUrl", "getUserBrandPermissions"]),
    invoicesAny() {
      return (this.invoices != null && this.invoices.length > 0)
    },
    selectedItemsAny() {
      return this.invoices.filter(e => e.selected).length > 0
    }
  },
  methods: {
    ...mapMutations(["setShowLoadingModal"]),
    ...mapActions("axios_mod", ["simpleFetch", "simpleMutation"]),
    currencyFormat,
    toggleAll(selected) {
      if (selected) {
        this.selectAll();
      } else {
        this.deselectAll();
      }
    },
    rowClicked(item) {
      this.$router.push({ name: "invoice", params: { id: item.id } });
    },
    selectAll() {
      this.invoices.forEach(e => e.selected = true);
    },
    deselectAll() {
      this.invoices.forEach(e => e.selected = false);
    },
    downloadInvoicesCsv() {
      this.setShowLoadingModal(true);
      let data = {
        query: `query {
          customerInvoicesCsv (customer_id: ${parseInt(this.$route.params.id)})
        }`
      };

      this.simpleFetch({ data, this_ref: this })
        .then(res => {
          if (res) {
            this.startDownloadCSV(res.customerInvoicesCsv);
          }
        })
        .finally(() => {
          this.setShowLoadingModal(false);
        });
    },
    updateInvoices() {
      const data = {
        query: `
          mutation InvoicesCustomerDataUpdate ($invoice_ids: [Int]) {
            res: InvoicesCustomerDataUpdate (invoice_ids: $invoice_ids)
          }
        `,
        variables: {
          invoice_ids: this.invoices.filter(inv => inv.selected).map(a => parseInt(a.id))
        }
      };

      this.simpleMutation({ data, this_ref: this }).then(() => {
        this.deselectAll();
      });
    },
    startDownloadCSV(csv) {
      let d = new Date();
      let d_string = `${d.getUTCFullYear()}-`;
      d_string += `${("0" + (d.getUTCMonth() + 1)).slice(-2)}-`;
      d_string += `${("0" + d.getUTCDate()).slice(-2)}`;

      let link = document.getElementById("csvdownloadlink");
      link.href = "data:Application/octet-stream," + encodeURIComponent(csv);
      link.style.display = "block";
      link.download = `${this.company_name}_invoices_${d_string}.csv`;
      link.click();
    },
    fetchTotalInvoices(){
      const data = {
        query: `query { Customer(id:${parseInt(this.customer)}){ invoices_total }}`
      };
      this.setShowLoadingModal(true);
      this.simpleFetch({ data, this_ref: this })
        .then(res => {
          if (res) {
            this.total = res.Customer.invoices_total;
          }
        })
        .finally(() => {
          this.setShowLoadingModal(false);
      });
    },
    fetchInvoices() {
      const offset = (this.currentPage-1) * this.perPage;
      const sort = this.sortDesc ? 'desc' : 'asc'
      const data = {
        query: `
        query { 
          Customer(id:${parseInt(this.customer)}){
            invoicesPagination (
              sortBy:"${this.sortBy}", 
              sort:"${sort}"
              limit: ${parseInt(this.perPage)},
              offset: ${parseInt(offset)}
            )
            {
                id
                invoice_no
                total_price
                total_price_ex_vat
                created_at
                sent_at
                sent_to
                is_paid
                selected: default_false
            }
          }
        }
        `
      };

      this.setShowLoadingModal(true);
      this.simpleFetch({ data, this_ref: this })
        .then(res => {
          if (res) {
            this.invoices = res.Customer.invoicesPagination;
          }
        })
        .finally(() => {
          this.setShowLoadingModal(false);
        });
    },
  },
  mounted() {
    this.fetchTotalInvoices();
  },
  watch:{
    total(n,o){
      if(this.total>0){
        this.fetchInvoices();
      }
    },
    currentPage(n,o){
      this.fetchInvoices();
    },
    perPage(n,o){
      this.fetchInvoices();
    },
    sortBy(n,o){
      this.fetchInvoices();
      // this.currentPage = 1; // To stay in the current page keep this commented, if after a sort it needs to go to the first page, uncomment
    },
    sortDesc(n,o){
      this.fetchInvoices();
      // this.currentPage = 1; // To stay in the current page keep this commented, if after a sort it needs to go to the first page, uncomment
    }
  }
};
</script>
